import { DEFAULT_LANGUAGE_VALUE } from '.';
import { Filter, Tags } from '../models';

export const INITIAL_TAGS: Tags = {
    explosionProtection: DEFAULT_LANGUAGE_VALUE,
    frequency: undefined,
    ratedPowerBasedOn: undefined,
    voltage: undefined,
    efficiencyClass: '',
    speed: null,
    power: null,
    frameMaterial: DEFAULT_LANGUAGE_VALUE,
    motorType: DEFAULT_LANGUAGE_VALUE,
    frameSize: '',
    mlfb: ''
};

export const TAGS = ['frequency', 'voltage', 'efficiencyClass', 'speed', 'ratedPowerBasedOn', 'power', 'frameMaterial', 'motorType', 'frameSize', 'mlfb', 'explosionProtection', 'startingVoltage', 'startingType', 'tolerance', 'temperatureClass', 'ac', 'aw', 'startingCondition', 'loadType', 'n0', 'n1', 'n2', 'n3', 'n4', 'm0', 'm1', 'm2', 'm3', 'm4', 'motorDriveConnection', 'gearboxInertia', 'gearboxN2', 'loadInertia', 'scaling'];

export const FILTER_TAGS = ['frequency', 'voltage', 'efficiencyClass', 'speed', 'ratedPowerBasedOn', 'power', 'frameMaterial', 'motorType', 'frameSize', 'mlfb', 'explosionProtection'];

export const REMOVABLE_TAG: Partial<Filter> = {
    efficiencyClass: '',
    speed: null,
    power: null,
    frameMaterial: DEFAULT_LANGUAGE_VALUE,
    motorType: DEFAULT_LANGUAGE_VALUE,
    frameSize: '',
    mlfb: ''
};

export const DEFAULT_LOAD_TAGS: Tags = {
    n0: undefined,
    n1: undefined,
    n2: undefined,
    n3: undefined,
    n4: undefined,
    m0: undefined,
    m1: undefined,
    m2: undefined,
    m3: undefined,
    m4: undefined
};
